/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Bottle_SizeInputs */

const en_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottle Size`)
};

const es_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de la botella`)
};

const fr_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de la bouteille`)
};

const de_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flaschengröße`)
};

const ja_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボトルサイズ`)
};

const zh_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瓶身容量`)
};

const ar_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجم الزجاجة`)
};

const id_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran Botol`)
};

const it_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Bottiglia`)
};

const ru_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер бутылки`)
};

const pt_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da Garrafa`)
};

const ko_field_bottle_size = /** @type {(inputs: Field_Bottle_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`병 크기`)
};

/**
* | output |
* | --- |
* | "Bottle Size" |
*
* @param {Field_Bottle_SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_bottle_size = /** @type {((inputs?: Field_Bottle_SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Bottle_SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_bottle_size(inputs)
	if (locale === "es") return es_field_bottle_size(inputs)
	if (locale === "fr") return fr_field_bottle_size(inputs)
	if (locale === "de") return de_field_bottle_size(inputs)
	if (locale === "ja") return ja_field_bottle_size(inputs)
	if (locale === "zh") return zh_field_bottle_size(inputs)
	if (locale === "ar") return ar_field_bottle_size(inputs)
	if (locale === "id") return id_field_bottle_size(inputs)
	if (locale === "it") return it_field_bottle_size(inputs)
	if (locale === "ru") return ru_field_bottle_size(inputs)
	if (locale === "pt") return pt_field_bottle_size(inputs)
	return ko_field_bottle_size(inputs)
});